import {
    ListItem,
    ListItemIcon,
    ListItemText,
    makeStyles,
} from '@material-ui/core';
import EmailIcon from '@mui/icons-material/Email';
import EventIcon from '@mui/icons-material/Event';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import Permissions from '../consts/Permissions';
import isPermissionGranted from '../helpers/isPermissionGranted';
import { ReactComponent as TestMenuIcon } from '../icons/catalogue.svg';
import { ReactComponent as DashboardIcon } from '../icons/dashboard.svg';
import { ReactComponent as MembersIcon } from '../icons/members.svg';
import { ReactComponent as TestsIcon } from '../icons/tests.svg';
import useStore from '../store/store';
import CustomTooltip from './CustomTooltip';

const MainMenuItems = ({ activePage, drawerOpen }) => {
    const classes = useStyles();
    const title = useStore((state) => state.title);

    const renderMenuItem = ({
        to,
        icon: Icon,
        extraIconMargin = false,
        label,
        expectedTitle,
    }) => {
        const isActive = title === expectedTitle;
        const listItem = (
            <ListItem
                button
                component={Link}
                to={to}
                replace
                className={clsx({ [classes.activeButton]: isActive })}
            >
                <ListItemIcon
                    className={clsx(
                        isActive ? classes.active : classes.inactive
                    )}
                >
                    <Icon
                        style={{
                            fontSize: 28,
                            margin: extraIconMargin ? 10 : 0,
                        }}
                    />
                </ListItemIcon>
                <ListItemText
                    primary={label}
                    classes={{
                        primary: clsx(
                            classes.menuItem,
                            isActive ? classes.active : classes.inactive
                        ),
                    }}
                />
            </ListItem>
        );

        return drawerOpen ? (
            listItem
        ) : (
            <CustomTooltip title={label} placement="right" variant="dark">
                {listItem}
            </CustomTooltip>
        );
    };

    return (
        <div className={classes.root}>
            {isPermissionGranted(Permissions.genome_portal) && (
                <>
                    {renderMenuItem({
                        to: '/',
                        icon: DashboardIcon,
                        label: 'Dashboard',
                        expectedTitle: 'Genome Portal - Dashboard',
                    })}
                    {renderMenuItem({
                        to: '/members',
                        icon: MembersIcon,
                        label: 'Members',
                        expectedTitle: 'Genome Portal - Members',
                    })}
                    {renderMenuItem({
                        to: '/menu',
                        icon: TestMenuIcon,
                        label: 'Test Menu',
                        expectedTitle: 'Genome Portal - Test Menu',
                    })}
                    {renderMenuItem({
                        to: '/contact',
                        icon: EmailIcon,
                        label: 'Contact Us',
                        expectedTitle: 'Genome Portal - Contact Us',
                        extraIconMargin: true,
                    })}
                    {renderMenuItem({
                        to: '/events',
                        icon: EventIcon,
                        label: 'News & Events',
                        expectedTitle: 'Genome Portal - News & Events',
                        extraIconMargin: true,
                    })}
                </>
            )}

            {isPermissionGranted(Permissions.admin_screen) && (
                <>
                    {renderMenuItem({
                        to: '/admin',
                        icon: MembersIcon,
                        label: 'Users',
                        expectedTitle: 'Admin - Users',
                    })}
                    {renderMenuItem({
                        to: '/admin/tests',
                        icon: TestsIcon,
                        label: 'Tests',
                        expectedTitle: 'Admin - Tests',
                    })}
                    {renderMenuItem({
                        to: '/contact',
                        icon: EmailIcon,
                        label: 'Contact Us',
                        expectedTitle: 'Genome Portal - Contact Us',
                        extraIconMargin: true,
                    })}
                </>
            )}
        </div>
    );
};

export default MainMenuItems;

const useStyles = makeStyles((theme) => ({
    root: {
        marginLeft: -12,
    },
    menuItem: {
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '1rem',
    },
    active: {
        color: theme.palette.secondary.main,
    },
    inactive: {
        color: theme.palette.primary.lighter,
    },
    activeButton: {
        backgroundColor: theme.palette.primary.light,
        '&:hover': {
            backgroundColor: theme.palette.primary.lighter,
        },
    },
}));
